// src/components/Charts/pie/MostUsedDrugsPieChart.jsx
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AnalyticsPieCard from './AnalyticsPieCard';
import { BASE_PIE_COLORS, OTHERS_COLOR } from '../../../constants/ColorsPalette';
import { urls } from '../../config/variables';
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';

export default function MostUsedDrugsPieChart({ chartId }) {
  const { t } = useTranslation('analytics');
  useContext(AppContext); // ensure providers are mounted
  useContext(AuthContext);

  return (
    <AnalyticsPieCard
      chartId={chartId}
      endpoint={urls.DRUGS_COUNT}
      i18n={{
        seriesName: t('MostUsedDrugs') || 'Most Used Drugs',
        centerLabel: t('Drugs') || 'Drugs',
        detailsButton: 'Drugs Details',
        dialogTitle: 'All Drugs',
        entityName: 'Drug',
        noData: t('NoData') || 'No data',
      }}
      nameKeys={['drug_name', 'name']}
      valueKeys={['drug_count', 'count']}
      parseResponse={(data) => {
        if (Array.isArray(data)) return { rows: data };
        if (data && Array.isArray(data.most_used_drugs)) return { rows: data.most_used_drugs };
        console.error('Unexpected response shape for MostUsedDrugs:', data);
        return { rows: [] };
      }}
      baseColors={BASE_PIE_COLORS}
      othersColor={OTHERS_COLOR}
      othersLabel="Others"
      useTopNWithOthers
      topN={14}
      />
  );
}